(function() {
    'use strict';

    angular.module('dstreamApp.components', ["flow", "dstreamApp.components.fileViewer"]);
})();